(function() {
  'use strict';

  angular
    .module('admin.users.details.username_changes.service', [])
    .factory('UsernameChangesService', UsernameChangesService);

  /** @ngInject */
  function UsernameChangesService($http, $q, API) {
    function list(userId) {
      var defer = $q.defer();

      $http
        .get(API.API_URL + "admin/users/" + userId + "/username_changes")
        .success(defer.resolve)
        .error(defer.reject);

      return defer.promise;
    }

    return{
      list: list
    };

  }

})();
